import type { Asset, AssetDetailType } from '@/common/asset';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type GetAssetSuccessResponseType = AssetDetailType;

export async function addAsset(assetPayload: Omit<Asset, 'id'>): Promise<GetAssetSuccessResponseType | null> {
	const response = await axios.post(`${API_URLS.ASSETS.INDEX}`, assetPayload);
	return getResponse<GetAssetSuccessResponseType>(response.data);
}
